module.exports = __webpack_public_path__ + "img/interest.075fd6c1.png";